import { Spin } from "antd";
import React from "react";
import styles from "./Page.module.css";

const LoadingPage = () => {
  return (
    <div className={styles.page}>
      <Spin size="large" />
    </div>
  );
};

export default LoadingPage;
